import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import { EasyBefore, modal1, loan_confirm } from "../../constant/Index";
import horwin from "../../assets/img/horwin.png";
import dummytext from "../../assets/img/applyloan.png";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import "../../assets/Css/Style.css";
import Captcha from "captcha-image";
import "../../assets/Css/applyforloan.css";
import { useForm } from "../../hooks/Form";
import { useApplyLoanMutation } from "../../store/services/ApplyloanServices";
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useDispatch, useSelector } from "react-redux";
import {
	setSuccess,
	clearMessage,
	clearVechicle_ID,
} from "../../store/reducers/globalReducers";
import { useProductsGetByIdQuery } from "../../store/services/ProductsServices";
import { useGetDriverProfileQuery } from "../../store/services/EditDrivingService";
import { useGetProfileQuery } from "../../store/services/AuthServices";

const ApplyForLoan = () => {
	const captchaImage = new Captcha(
		"48px Courier",
		"center",
		"middle",
		730,
		200,
		"#abd5d6",
		"#142379",
		5,
	).createImage();
	const [data, setData] = useState({ image: captchaImage });
	const { image } = data;
	const [showModal, setShowModal] = useState("");

	function handleClick(e) {
		e.preventDefault();
		captchaImage(setData({ ...data, image: captchaImage }));
	}

	function createMarkup(source) {
		return { __html: source };
	}
	function MyCaptcha() {
		return <div dangerouslySetInnerHTML={createMarkup(image)} />;
	}
	const { user } = useSelector((state) => state.AuthReducer);
	let { data: userData, isFetching } = useGetProfileQuery();
	let { data: DrivingData, isLoading: drivingLoad } =
		useGetDriverProfileQuery();
	let driverProfile = DrivingData?.response?.data;
	let usersDetails = userData?.response?.data;
	console.log(driverProfile, ":::::::::::");
	const [termsCheck, setTermsCheck] = useState(false);
	const [termsCheck2, setTermsCheck2] = useState(false);
	const [errors, setErrors] = useState([]);
	const [errorsCap, errorCapture] = useState();
	const { state, onChange, setState } = useForm({
		first_name: "",
		last_name: "",
		mobile: "",
		area: "",
		city: "",
		state: "",
		revenues: "",
		driver_license_info: "",
		company_details: "",
		message: "",
		captureValue: "",
	});
	let { success, vehicle_id } = useSelector((state) => state.globalReducer);
	const { data: products, isLoading } = useProductsGetByIdQuery(vehicle_id);
	const [LoanApply, response] = useApplyLoanMutation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let number = data?.image?.split(" data-key=")[1];
	let sliceNumber = number?.slice(1, 6);

	useEffect(() => {
		setState({
			first_name: usersDetails?.first_name,
			last_name: usersDetails?.last_name,
			mobile: usersDetails?.contact_no,
			revenues: driverProfile?.revenue,
			driver_license_info: driverProfile?.driver_license_info,
			company_details: driverProfile?.company_details,
		});
	}, [drivingLoad === true || isFetching === true]);

	const onSubmit = (e) => {
		e.preventDefault();
		if (sliceNumber === state?.captureValue) {
			if (termsCheck && termsCheck2) {
				const FormDatas = new FormData();
				FormDatas.append("first_name", state.first_name);
				FormDatas.append("last_name", state.last_name);
				FormDatas.append("vehicle_id", vehicle_id);
				FormDatas.append("user_id", user?.id);
				FormDatas.append("mobile", state.mobile);
				FormDatas.append("area", state.area);
				FormDatas.append("city", state.city);
				FormDatas.append("state", state.state);
				FormDatas.append("driver_license_info", state.driver_license_info);
				FormDatas.append("company_details", state.company_details);
				FormDatas.append("revenues", state.revenues);
				FormDatas.append("message", state.message);
				LoanApply(FormDatas);
			} else {
				ToastMessage(
					termsCheck2
						? "I agree to Authorization for Credit Check"
						: "I agree to three wheels agents calling me on my provided number",
				);
			}
		}
		return errorCapture("Wrong Captcha Number, Please Try Again");
	};

	useEffect(() => {
		return () => {
			dispatch(clearVechicle_ID());
			dispatch(clearMessage());
		};
	}, []);

	useEffect(() => {
		if (success === "data received successfully") {
			setShowModal("fade show d-block");
			state.first_name = "";
			state.last_name = "";
			state.mobile = "";
			state.area = "";
			state.city = "";
			state.state = "";
			state.driver_license_info = "";
			state.company_details = "";
			state.revenues = "";
			state.message = "";
			errorCapture();
		}
		return () => {
			dispatch(clearVechicle_ID());
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			errorCapture();
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);

	return (
		<>
			<section className="applyforloan_page">
				<div className="right-before">
					<figure>
						<img src={EasyBefore} alt="" className="img-fluid" />
					</figure>
				</div>
				{/* Header */}
				<Header />
				{/* Header */}
				<section class="breadcrums_sec">
					<div className="container">
						<div className="home-and-product pt-5">
							<p>
								<Link to="/">Home</Link> {">"}{" "}
								<Link to="/">Loan</Link>
							</p>
						</div>
					</div>
				</section>
				<section className="contactus_head">
					<div className="container">
						<div className="row">
							{/* <div className="col-md-2"></div> */}
							<div className="col-md-9 mx-auto">
								<h2 className="text-center">
									Apply for <span className="colored">loan </span>
								</h2>
								<p className="text-center">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p>
							</div>
							{/* <div className="col-md-2"></div> */}
						</div>
					</div>
				</section>
				<section className="contact_form_sec">
					<div className="container">
						<div className="row">
							<div className="col-md-2"></div>
							<div className="col-md-8">
								<div className="form_start">
									<form onSubmit={onSubmit}>
										<div className="row">
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.first_name
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputname"
														placeholder="First Name"
														name="first_name"
														value={state?.first_name}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.first_name && (
													<span className="errorMessage">
														<p>{errors && errors?.first_name}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.last_name
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputlname"
														placeholder="Last Name"
														name="last_name"
														value={state?.last_name}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.last_name && (
													<span className="errorMessage">
														<p>{errors && errors?.last_name}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="number"
														className={`${
															errors && errors?.mobile
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputmobile"
														placeholder="Mobile"
														name="mobile"
														value={state?.mobile}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.mobile && (
													<span className="errorMessage">
														<p>{errors && errors?.mobile}</p>
													</span>
												)}
											</div>

											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.area
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputarea"
														placeholder="Area"
														name="area"
														value={state?.area}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.area && (
													<span className="errorMessage">
														<p>{errors && errors?.area}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.city
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputcity"
														placeholder="City"
														name="city"
														value={state?.city}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.city && (
													<span className="errorMessage">
														<p>{errors && errors?.city}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.state
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputstate"
														placeholder="State"
														name="state"
														value={state?.state}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.state && (
													<span className="errorMessage">
														<p>{errors && errors?.state}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.revenues
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputrevenue"
														placeholder="Revenues"
														name="revenues"
														value={state?.revenues}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.revenues && (
													<span className="errorMessage">
														<p>{errors && errors?.revenues}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.driver_license_info
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputdli"
														placeholder="Driver License Info"
														name="driver_license_info"
														value={state?.driver_license_info}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.driver_license_info && (
													<span className="errorMessage">
														<p>{errors && errors?.driver_license_info}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.company_details
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputdetail"
														placeholder="Company Details"
														company_details
														name="company_details"
														value={state?.company_details}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.company_details && (
													<span className="errorMessage">
														<p>{errors && errors?.company_details}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div class="form-group">
													<select
														class="form-control"
														name="carsCate"
														id="cars"
														onChange={onChange}
														value={products?.response?.data?.title}
													>
														<option disabled selected>
															Select Vehicles
														</option>

														<option value={products?.response?.data?.title}>
															{products?.response?.data?.title}
														</option>
													</select>
													{/* <select
														class="form-control"
														id="exampleFormControlSelect1"
													>
														<option data-thumbnail="<img src={horwin} />">
															Horwin EK1
														</option>
														<option>Horwin EK1</option>
														<option>Horwin EK1</option>
														<option>Horwin EK1</option>
														<option>Horwin EK1</option>
													</select> */}
												</div>
											</div>
											<div className="col-md-12">
												<div class="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.message
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputname"
														placeholder="Message"
														name="message"
														value={state?.message}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.message && (
													<span className="errorMessage">
														<p>{errors && errors?.message}</p>
													</span>
												)}
											</div>
											<div className="col-md-12">
												{/* <div className="applyloanimg">
													<img src={dummytext} className="img-fluid" alt="" />
												</div> */}

												<MyCaptcha />
												<div style={{ position: "relative" }}>
													<button
														onClick={handleClick}
														style={{
															border: "none",
															color: "#354a8d",
															fontSize: "30px",
															outline: "none",
															cursor: "pointer",
															position: "absolute",
															top: "5px",
															right: "0",
														}}
													>
														<i class="fa fa-spinner" aria-hidden="true"></i>
													</button>
												</div>
											</div>
											<div className="col-md-12 mt-4">
												<div class="form-group mt-4">
													<input
														type="text"
														className={`${
															errorsCap
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputname"
														placeholder="Enter  the Above text"
														name="captureValue"
														value={state?.captureValue}
														onChange={onChange}
													/>
												</div>
												{errorsCap ? (
													<span className="errorMessage">
														<p>{errorsCap}</p>
													</span>
												) : null}
											</div>
											<div className="col-md-12 mt-2">
												<div class="form-group custom_checkbox">
													<input
														type="checkbox"
														id="agentcheck1"
														checked={termsCheck2}
														onChange={(e) => {
															setTermsCheck2(e.target.checked);
														}}
													/>
													<label for="agentcheck1">
														{" "}
														I agree to three wheels agents calling me on my
														provided number.
													</label>
												</div>
											</div>
											<div className="col-md-12">
												<div class="form-group custom_checkbox">
													<input
														type="checkbox"
														id="agentcheck2"
														checked={termsCheck}
														onChange={(e) => {
															setTermsCheck(e.target.checked);
														}}
													/>
													<label for="agentcheck2">
														{" "}
														I agree to Authorization for Credit Check
													</label>
												</div>
											</div>
											<div className="col-md-12">
												<div className="button-group">
													<button type="submit" className="btn">
														Submit
													</button>
												</div>
											</div>
											{/* <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLongTitle">Modal title</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div className="confirm_text_start">
                                <div className="row">
                                  <div className="col-md-6">
                                    <figure>
                                      <img src={ loan_img } alt="" className="img-fluid" />
                                    </figure>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="confrim_text">
                                      <h5>Would You Like To</h5>
                                      <h4>Apply for Loan</h4>
                                      <p>Vitae semper quis lectus nulla at volutpat diam ut. Adipiscing elit pellentesque habitant morbi tristique. </p>
                                      <button type="button" className="btn">Yes</button>
                                      <button type="button" className="btn gray">Not Now</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
										</div>
									</form>
								</div>
							</div>
							<div className="col-md-2"></div>
						</div>
					</div>
				</section>
				{/* Footer */}
				<Footer />
				{/* Footer */}
			</section>

			{/* <button
        type="button"
        class="btn btn-primary"
        
      >
        Launch demo modal
      </button> */}

			<div
				class={`modal applyforloan_page fade ${showModal}`}
				id="exampleModalCenter2"
				tabindex="-1"
				role="dialog"
				aria-labelledby="exampleModalCenterTitle2"
				aria-hidden="true"
			>
				<div class="modal-dialog apply-loan h-100" role="document">
					<div class="modal-content ">
						<div class="modal-body ">
							<div className="apply-loan h-100">
								<div className="row py-5">
									<div className="col-md-5  ">
										<div className="apply-loan-img">
											<img className="img-fluid" src={loan_confirm}></img>
										</div>
									</div>

									<div className="col-md-6">
										<div className="modal-apply-loan-text">
											<h2>Thank You!</h2>
											<h3>For Applying For loan</h3>
											<p>
												Vitae semper quis lectus nulla at volutpat diam ut.
												Adipiscing elit pellentesque habitant morbi tristique.
											</p>
											<div className="two-btns-apply-loan">
												<button
													className="bg-btn w-75"
													data-dismiss="modal"
													style={{ cursor: "pointer" }}
													onClick={() => navigate("/")}
												>
													Continue To home page
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ApplyForLoan;
